export default "__VITE_ASSET__BfKOvXCY__"